import { createFileRoute } from "@tanstack/react-router";

import { EngVelocityDashboard } from "../tools/dashboards/EngVelocityDashboard";
import { isEngVelocityView, type EngVelocityView } from "../tools/dashboards/aiEngineeringTypes";

function EngVelocityRoute() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();

  return (
    <EngVelocityDashboard
      view={search.view ?? "velocity"}
      onViewChange={(view) =>
        navigate({
          search: view === "velocity" ? {} : { view },
        })
      }
    />
  );
}

export const Route = createFileRoute("/_app/dashboards/eng-velocity")({
  component: EngVelocityRoute,
  validateSearch: (search: Record<string, unknown>): { view?: EngVelocityView } => {
    if (typeof search.view === "string" && isEngVelocityView(search.view)) {
      return { view: search.view };
    }
    return {};
  },
});
